/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { customElement } from 'lit-element';
import settings from 'carbon-components/es/globals/js/settings';
import BXButton from '../button/button';
import buttonStyles from '../button/button.scss';
import styles from './modal.scss';

const { prefix } = settings;

/**
 * Modal footer button.
 * @element bx-modal-footer-button
 */
@customElement(`${prefix}-modal-footer-button`)
class BXModalFooterButton extends BXButton {
  static styles = [buttonStyles, styles]; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default BXModalFooterButton;
